import { Portal } from 'semantic-ui-react';

export default Portal;
